import {
  MaterialKeywordsInput,
  MaterialKeywordsRefHandle,
} from 'components/NewMaterialSelector/MaterialKeywordsInput'
import _ from 'lodash'
import React from 'react'
import { EditorProps } from 'react-data-grid'
import { Key } from 'utils/keyCodes'
import { useOrganizationAndProjectContext } from 'utils/useOrganizationContext'
import { useDataGridEditorNavigation } from './useDataGridEditorNavigation'

export function MaterialKeywordDataGridEditor<TRow, TSummaryRow>({
  row,
  column,
  onRowChange,
  onClose,
  rootElementClassName,
  showGroups,
  disableLabel,
}: EditorProps<TRow, TSummaryRow> & {
  rootElementClassName?: string
  showGroups?: string[]
  disableLabel?: boolean
}) {
  const { handleNavigationKeys } = useDataGridEditorNavigation(() => {
    onClose(true)
  }, true)
  const { projectId } = useOrganizationAndProjectContext()

  const materialInputRef = React.useRef<MaterialKeywordsRefHandle>(null)

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === Key.Enter) {
      // needed to not close the editor on enter (ie user selected a keyword with Enter key)
      event.preventDefault()
      event.stopPropagation()
    } else {
      handleNavigationKeys(event)
    }
  }

  return (
    <div onKeyDown={handleKeyDown} style={{ width: '100%', height: '100%' }}>
      <MaterialKeywordsInput
        ref={materialInputRef}
        rootMaterialKeywordsInputClassName={rootElementClassName}
        projectId={projectId}
        onChangeTokens={(tokens) => {
          onRowChange({
            ...row,
            [column.key]: tokens,
          })
        }}
        enableSaveOnChange
        selectedTokens={
          !row['thumbnail3d'] && _.isEmpty(row[column.key])
            ? {
                materialgroup: [
                  {
                    category: 'meterialgroup',
                    originalKeyword: 'sheet',
                    translationKey: 'sheet',
                  },
                ],
              }
            : row[column.key]
        }
        onBlur={() => onClose(true)}
        autoFocus
        startOpen
        disableUnderline
        disableLabel={disableLabel}
        showGroups={showGroups}
      />
    </div>
  )
}
